import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransactionModel } from 'data/transactions/transaction.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: TransactionModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<TransactionModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const transactionSlice = createSlice({
  name: 'transaction',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default transactionSlice;
